const PostDefaultModel = {
    type: 'post',
    name: 'default',
    slugPrefix: 'blog',
    blocks: [
        {
            name: 'breadcrumbs',
            type: 'link',
        },
        {
            name: 'image', // name or id; MUST be unique
            max: 2, // max same items allowed
            type: 'image', // || text || link || image || mixed (with children)
            preview: 'first', // SSR truncation: keep only the first image on associated (isPartial) contents
        },
        {
            name: 'title', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'text', // || text || link || image || mixed (with children)
            preview: 'full',
        },
        {
            name: 'date', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'date', // || text || link || image || mixed (with children)
            preview: 'full',
        },
        {
            // Editorial last-update date, feeding BlogPosting.dateModified. Optional: left empty,
            // the post falls back to the document's own dates.updated. Fill it only when the post
            // was genuinely revised, since bulk scripts (translations, schema backfills) bump
            // dates.updated on every document and would otherwise fake a site-wide refresh.
            name: 'dateModified',
            label: 'Date de mise à jour',
            max: 1,
            type: 'date',
            preview: 'full',
        },
        {
            name: 'tags', // name or id; MUST be unique
            type: 'text', // || text || link || image || mixed (with children)
            preview: 'full',
        },
        {
            name: 'excerpt', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'html', // || text || link || image || mixed (with children)
            preview: 'full',
        },
        {
            name: 'schema', // name or id; MUST be unique
            label: 'Schema (JSON-LD)',
            max: 1, // max same items allowed
            type: 'textarea', // raw JSON-LD injected in the <head> script
        },
        {
            name: 'content',
            type: 'mixed',
            blocks: [
                {
                    name: 'text', // name or id; MUST be unique
                    max: 1, // max same items allowed
                    type: 'html', // || text || link || image || mixed (with children)
                },
                {
                    name: 'image',
                    type: 'image',
                    max: 1,
                },
                {
                    name: 'call-to-action',
                    type: 'link',
                    max: 1,
                },
                {
                    name: 'promotion',
                    max: 1,
                    type: 'panel',
                },
                {
                    name: 'position',
                    type: 'select',
                    max: 1,
                    options: ['left', 'right'],
                },
            ],
        },
        {
            name: 'relatedProducts',
            type: 'product',
            preview: 'full', // kept on truncated posts: client-side related-posts matching (getRelatedContentsByProducts) reads these product ids
        },
		{
            name: 'relatedPanels',
            type: 'panel',
		},
    ],
};
export default PostDefaultModel;
